import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { CommitmentResponses } from './wig-daily-dynamic-commitment-form.model';

@Injectable()
export class WigDailyDynamicCommitmentFormService extends BaseService {
  responseDailyCommitment(response: CommitmentResponses): Promise<any> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { responseType: 'text' as 'json', headers: httpHeaders };

    return this.httpClient
      .post<any>(this.serviceUrl + '/driverwig/commitmentResponses', response, requestOptions)
      .toPromise();
  }

  protected getEndPoint(): string {
    return '/driverwig/api/v1';
  }
}
